import {
	intersect,
	literal,
	nullable,
	number,
	partial,
	string,
	struct,
	tuple,
	union,
} from 'io-ts/Decoder';

export const DateFilter = union(
	intersect(
		struct({
			type: union(literal('past'), literal('future')),
		})
	)(
		partial({
			amount: number,
			metric: union(
				literal('days'),
				literal('weeks'),
				literal('months'),
				literal('calendar-month')
			),
		})
	),
	intersect(
		struct({
			type: literal('both'),
		})
	)(
		partial({
			from: struct({
				amount: number,
				metric: union(literal('days'), literal('weeks'), literal('months')),
			}),
			to: struct({
				amount: number,
				metric: union(literal('days'), literal('weeks'), literal('months')),
			}),
		})
	),
	intersect(
		struct({
			type: literal('between'),
		})
	)(
		partial({
			values: tuple(string, nullable(string)),
		})
	)
);
